import { Fragment, useEffect, useState } from 'react';
import classes from './register-select.module.css';
import { StringUtils } from '../../../utils/helper_functions';
import { Option } from '../../../utils/helper-interfaces';

interface DropdownProps {
  options: Option[];
  defaultValue?: string;
  id: string;
  onChange?: (value: string) => void; // Optional onChange handler for the parent component
}

const RegisterSelectBox: React.FC<DropdownProps> = (props) => {

  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedValue(value);
    if (props.onChange) {
      props.onChange(value); // Notify the parent of the change
    }
  };
  // Sync internal state with defaultValue if it changes
  useEffect(() => {
    setSelectedValue(props.defaultValue || null);
  }, [props.defaultValue]);
  return (
    <Fragment>
      <div className={classes['label-wrapper']}>
        <label htmlFor={props.id}>{StringUtils.capitalizeFirstLetter(props.id)}</label>
      </div>
        <select
          
          id={props.id}
          className={classes.textbox}
          name={props.id}
          value={selectedValue || ''}
          onChange={handleChange}>
            <option value="" disabled>
          Select your {props.id}
        </option>
        {props.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
            </select>
    </Fragment>
  );
};

export default RegisterSelectBox;
